import { ComuneDto, Configuration, OnboardingApi, ProvinceDto } from "@api/client";
import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import { PROVINCE } from "constants/province";
import { ThunkApiConfig } from "core/store";
import getConfiguration, { errorHandler } from "./config";

const enum CommonReducer {
	showLoader = "[COMMON] Show loader",
	hideLoader = "[COMMON] Hide loader",
	initApp = "[COMMON] Init app",
	getProvince = "[COMMON] Get Province",
	getComuni = "[COMMON] Get Comuni",
}

export const showLoader = createAction(CommonReducer.showLoader);

export const hideLoader = createAction(CommonReducer.hideLoader);

export const commonInitApp = createAsyncThunk<void, void, ThunkApiConfig>(
	CommonReducer.initApp,
	async (_, { dispatch }) => {
		await dispatch(commonGetProvince());

		return;
	}
);

export const commonGetProvince = createAsyncThunk<ProvinceDto[] | undefined, void, ThunkApiConfig>(
	CommonReducer.getProvince,
	async (_, { dispatch, extra, getState }) => {
		try {
			return new Promise((resolve) => {
				resolve(PROVINCE);
			});
			// return await new OnboardingApi(
			// 	getConfiguration(Configuration, extra, getState)
			// ).elencoProvince();
		} catch (error) {
			errorHandler(error, dispatch);
		}
	}
);

export const commonGetComuni = createAsyncThunk<ComuneDto[] | undefined, string, ThunkApiConfig>(
	CommonReducer.getComuni,
	async (provincia, { dispatch, extra, getState }) => {
		let comuni = getState()?.common?.comuni;
		let province = getState().common?.province;
		let prov = province?.find((p) => p.siglaProvincia == provincia)?.provincia;

		if (!!comuni?.[provincia] || !prov) return;

		try {
			return await new OnboardingApi(
				getConfiguration(Configuration, extra, getState)
			).listaComuniByProvincia1({ provincia: prov });
		} catch (error) {
			errorHandler(error, dispatch);
		}
	}
);
